import { render } from "./MapCourse.vue?vue&type=template&id=3620a73b&ts=true"
import script from "./MapCourse.vue?vue&type=script&lang=ts"
export * from "./MapCourse.vue?vue&type=script&lang=ts"

import "./MapCourse.vue?vue&type=style&index=0&id=3620a73b&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__